import React from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../../layouts/app/AppLayout';
import './custom.scss';

import { translateThis } from '../../helpers/language.helper';
import AppIcons from '../../assets/images/icons';
import SVGIcons from '../../assets/images/icons/svgIcons';
import herClubDoc from '../../assets/images/projects/Her-club-21-1.pdf';




const HerClubProject = () => {
    // custom home functions here
    const pageName = "Projects";

    const onButtonClick = () => {
        const pdfUrl = `${herClubDoc}`;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "Her-club-21-1.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <AppLayout
            pageName={pageName}
        >

            <div className="main-content-wrapper individual-project-wrapper f-wrp">
                <div className='individualProject-main-banner f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='banner-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                    <div className='banner-content-box f-wrp'>
                                        <div className='content-main-box f-wrp'>
                                            <h2>{translateThis("Her Club By Dolly")}</h2>
                                            <h1>{translateThis("Supporting in education, health, agriculture and economic development")}</h1>
                                            <div className='btn-wrp'>
                                                <Link to={'/join-our-community'} className='sqr-btn'>{translateThis('Join our mission')}</Link>
                                                <Link to={'/projects/her-cub-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12">
                                    <div className='banner-img-sec f-wrp'>
                                        <span className='banner-main-img'><img src={AppIcons.projectBanner1} alt='about us' /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='whatWeDo-main-block f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='whatWeDo-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                                    <div className='whatWeDo-block-box f-wrp'>
                                        <h2>{translateThis("What we do")}</h2>
                                        <p>{translateThis("What we do Text")}</p>
                                        <div className='btn-wrp'>
                                            <Link to={'/projects/her-cub-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                                    <div className='content-sub-box f-wrp'>
                                        <div className='each-content-box moreThan f-wrp'>
                                            <p>{translateThis("More than")}</p>
                                            <h2>{translateThis("70%")}</h2>
                                            <p>{translateThis("moreThanText")}</p>
                                        </div>
                                        <div className='each-content-box upTo f-wrp'>
                                            <p>{translateThis("Up to")}</p>
                                            <h2>{translateThis("80%")}</h2>
                                            <p>{translateThis("upToText")}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='aboutUs-main-block f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='aboutUs-content-wrp f-wrp'>
                            <div className='row'>
                                <div className="col-lg-7 col-md-6 col-sm-12 col-xs-12">
                                    <div className='aboutUs-img-sec f-wrp'>
                                        <span className='aboutUs-main-img'><img src={AppIcons.projAbout} alt='about us' /></span>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                                    <div className='aboutUs-content-sec f-wrp'>
                                        <div className='aboutUs-intro-box f-wrp'>
                                            <h1>{translateThis("About")}<b>{translateThis("us")}</b></h1>
                                            <p>{translateThis("aboutIntroText")}</p>
                                            <div className='btn-wrp'>
                                                <Link to={'/projects/her-cub-details'} className='pln-btn'>{translateThis('Learn more')} <SVGIcons.LearnMoreArrow /></Link>
                                            </div>
                                        </div>
                                        <div className='story-intro-box f-wrp'>
                                            <h4><b>{translateThis("Touching stories")}</b></h4>
                                            <p>{translateThis("touchingStoriesText")}</p>
                                            <div className='btn-wrp'>
                                                <Link onClick={onButtonClick} className='pln-btn'>{translateThis('Download full document')} <SVGIcons.LearnMoreArrow /></Link>
                                                {/* <Button onClick={onButtonClick} className='pln-btn'>{translateThis('Download full document')} <SVGIcons.LearnMoreArrow /></Button> */}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default HerClubProject;